import {
  TrancheStatusOption,
  EmploymentOption,
  ForCauseOption,
  ReasonForSeparationOption,
  ResignedOption,
  UserAccountStatusOption,
  ReviewStatusOption,
  AnnualChartOption,
  SivStatusOption,
  SivStatus,
  FlagType,
  FlagTypeOption,
} from 'types';

export const annualChartOptions: Array<AnnualChartOption> = [
  {
    value: 'tranched_candidate_count',
    label: 'Tranched Candidates',
  },
  {
    value: 'newly_created_org_count',
    label: 'New Organizations',
  },
  {
    value: 'newly_reviewable_org_count',
    label: 'New Invites',
  },
  {
    value: 'new_candidate_count',
    label: 'New Candidates',
  },
  {
    value: 'signed_candidate_count',
    label: 'Signed Candidates',
  },
  {
    value: 'review_count',
    label: 'Review Count',
  },
];

export const reviewStatusOptions: Array<ReviewStatusOption> = [
  {
    value: 'pending_user_review',
    label: 'Pending',
  },
  {
    value: 'review_in_progress',
    label: 'In Progress',
  },
  {
    value: 'did_not_work_insufficient_info',
    label: 'Insufficient Info',
  },
  {
    value: 'did_not_work_certain',
    label: 'Did Not Work',
  },
  {
    value: 'reviewed_and_verified',
    label: 'Reviewed',
  },
  {
    value: 'unable_to_review',
    label: 'Unable To Review',
  },
];

export const trancheStatusObject: Array<TrancheStatusOption> = [
  {
    value: 'signature_pending',
    label: 'Signature Pending',
  },
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'sent_to_state',
    label: 'Sent To State',
  },
  {
    value: 'skipped',
    label: 'Skipped',
  },
];

export const userAccountStatusOptions: Array<UserAccountStatusOption> = [
  {
    label: 'Pending',
    value: 'pending',
  },
  {
    label: 'Active',
    value: 'active',
  },
  {
    label: 'Inactive',
    value: 'inactive',
  },
  {
    label: 'Created',
    value: 'created',
  },
  {
    label: 'Force Change Password',
    value: 'force_change_password',
  },
  { label: 'Disabled', value: 'disabled' },
];

export const reasonForSeparationChoicesObject: Array<ReasonForSeparationOption> =
  [
    {
      value: 'currently_employed',
      label: 'Currently Employed',
    },
    {
      value: 'resigned',
      label: 'Resigned',
    },
    {
      value: 'end_of_contract',
      label: 'End of Contract/No Position Available',
    },
    {
      value: 'deceased',
      label: 'Deceased',
    },
    {
      value: 'for_cause',
      label: 'Terminated For Cause',
    },
  ];

export const forCauseChoicesObject: Array<ForCauseOption> = [
  {
    value: 'security_ineligible',
    label: 'Security ineligible',
  },
  {
    value: 'denied_base_access',
    label: 'Banned or terminated by military/Denied base access',
  },
  {
    value: 'policy_violation',
    label: 'Violation of policy',
  },
  {
    value: 'theft',
    label: 'Theft',
  },
  {
    value: 'drug_use',
    label: 'Drug use/failed drug test',
  },
  {
    value: 'fighting',
    label: 'Physical altercation/fighting',
  },
  {
    value: 'fraud',
    label: 'Fraud',
  },
  {
    value: 'job_abandonment',
    label: 'Job abandonment',
  },
  {
    value: 'mission_refusal',
    label: 'Mission Refusal',
  },
  {
    value: 'poor_performance',
    label: 'Poor performance',
  },
  {
    value: 'other',
    label: 'Other Reason',
  },
];

export const resignedChoicesObject: Array<ResignedOption> = [
  {
    value: 'personal_reasons',
    label: 'Personal Reasons',
  },
  {
    value: 'us_visa',
    label: 'Received US Visa',
  },
  {
    value: 'unknown',
    label: 'Unknown',
  },
  {
    value: 'other',
    label: 'Other Reason',
  },
];

export const employmentDetailsOption = [
  ...forCauseChoicesObject,
  ...resignedChoicesObject,
];
export const employmentOptions: Array<EmploymentOption> = [
  { label: 'Full Time', value: 'FULLTIME' },
  { label: 'Part Time', value: 'PARTTIME' },
  { label: 'Unknown', value: 'UNKNOWN' },
];
export const countryConfimationOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const countryOptions = [
  { label: 'Afghanistan', value: 'AF' },
  { label: 'United States of America', value: 'US' },
  { label: 'Albania', value: 'AL' },
  { label: 'Algeria', value: 'DZ' },
  { label: 'Andorra', value: 'AD' },
  { label: 'Angola', value: 'AO' },
  { label: 'Anguilla', value: 'AI' },
  { label: 'Antarctica', value: 'AQ' },
  { label: 'Argentina', value: 'AR' },
  { label: 'Armenia', value: 'AM' },
  { label: 'Aruba', value: 'AW' },
  { label: 'Australia', value: 'AU' },
  { label: 'Austria', value: 'AT' },
  { label: 'Azerbaijan', value: 'AZ' },
  { label: 'Bahamas', value: 'BS' },
  { label: 'Bahrain', value: 'BH' },
  { label: 'Bangladesh', value: 'BD' },
  { label: 'Barbados', value: 'BB' },
  { label: 'Belarus', value: 'BY' },
  { label: 'Belgium', value: 'BE' },
  { label: 'Belize', value: 'BZ' },
  { label: 'Benin', value: 'BJ' },
  { label: 'Bermuda', value: 'BM' },
  { label: 'Bhutan', value: 'BT' },
  { label: 'Bolivia', value: 'BO' },
  { label: 'Bonaire Sint Eustatius and Saba', value: 'BQ' },
  { label: 'Bosnia and Herzegovina', value: 'BA' },
  { label: 'Botswana', value: 'BW' },
  { label: 'Bouvet Island', value: 'BV' },
  { label: 'Brazil', value: 'BR' },
  { label: 'Brunei Darussalam', value: 'BN' },
  { label: 'Bulgaria', value: 'BG' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Burundi', value: 'BI' },
  { label: 'Cabo Verde', value: 'CV' },
  { label: 'Cambodia', value: 'KH' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Canada', value: 'CA' },
  { label: 'Cayman Islands (the)', value: 'KY' },
  { label: 'Central African Republic (the)', value: 'CF' },
  { label: 'Chad', value: 'TD' },
  { label: 'Chile', value: 'CL' },
  { label: 'China', value: 'CN' },
  { label: 'Christmas Island', value: 'CX' },
  { label: 'Cocos (Keeling) Islands (the)', value: 'CC' },
  { label: 'Colombia', value: 'CO' },
  { label: 'Comoros (the)', value: 'KM' },
  { label: 'Congo (the Democratic Republic of the)', value: 'CD' },
  { label: 'Congo (the)', value: 'CG' },
  { label: 'Cook Islands (the)', value: 'CK' },
  { label: 'Costa Rica', value: 'CR' },
  { label: 'Croatia', value: 'HR' },
  { label: 'Cuba', value: 'CU' },
  { label: 'Curaçao', value: 'CW' },
  { label: 'Cyprus', value: 'CY' },
  { label: 'Czechia', value: 'CZ' },
  { label: "Côte d'Ivoire", value: 'CI' },
  { label: 'Denmark', value: 'DK' },
  { label: 'Djibouti', value: 'DJ' },
  { label: 'Dominica', value: 'DM' },
  { label: 'Dominican Republic', value: 'DO' },
  { label: 'Ecuador', value: 'EC' },
  { label: 'Egypt', value: 'EG' },
  { label: 'El Salvador', value: 'SV' },
  { label: 'Equatorial Guinea', value: 'GQ' },
  { label: 'Eritrea', value: 'ER' },
  { label: 'Estonia', value: 'EE' },
  { label: 'Eswatini', value: 'SZ' },
  { label: 'Ethiopia', value: 'ET' },
  { label: 'Falkland Islands (the)', value: 'FK' },
  { label: 'Faroe Islands (the)', value: 'FO' },
  { label: 'Fiji', value: 'FJ' },
  { label: 'Finland', value: 'FI' },
  { label: 'France', value: 'FR' },
  { label: 'French Guiana', value: 'GF' },
  { label: 'French Polynesia', value: 'PF' },
  { label: 'French Southern Territories (the)', value: 'TF' },
  { label: 'Gabon', value: 'GA' },
  { label: 'Gambia (the)', value: 'GM' },
  { label: 'Georgia', value: 'GE' },
  { label: 'Germany', value: 'DE' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Gibraltar', value: 'GI' },
  { label: 'Greece', value: 'GR' },
  { label: 'Greenland', value: 'GL' },
  { label: 'Grenada', value: 'GD' },
  { label: 'Guadeloupe', value: 'GP' },
  { label: 'Guam', value: 'GU' },
  { label: 'Guatemala', value: 'GT' },
  { label: 'Guernsey', value: 'GG' },
  { label: 'Guinea', value: 'GN' },
  { label: 'Guinea-Bissau', value: 'GW' },
  { label: 'Guyana', value: 'GY' },
  { label: 'Haiti', value: 'HT' },
  { label: 'Heard Island and McDonald Islands', value: 'HM' },
  { label: 'Holy See (the)', value: 'VA' },
  { label: 'Honduras', value: 'HN' },
  { label: 'Hong Kong', value: 'HK' },
  { label: 'Hungary', value: 'HU' },
  { label: 'Iceland', value: 'IS' },
  { label: 'India', value: 'IN' },
  { label: 'Indonesia', value: 'ID' },
  { label: 'Iran (Islamic Republic of)', value: 'IR' },
  { label: 'Iraq', value: 'IQ' },
  { label: 'Ireland', value: 'IE' },
  { label: 'Isle of Man', value: 'IM' },
  { label: 'Israel', value: 'IL' },
  { label: 'Italy', value: 'IT' },
  { label: 'Jamaica', value: 'JM' },
  { label: 'Japan', value: 'JP' },
  { label: 'Jersey', value: 'JE' },
  { label: 'Jordan', value: 'JO' },
  { label: 'Kazakhstan', value: 'KZ' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Kiribati', value: 'KI' },
  { label: "Korea (the Democratic People's Republic of)", value: 'KP' },
  { label: 'Korea (the Republic of)', value: 'KR' },
  { label: 'Kuwait', value: 'KW' },
  { label: 'Kyrgyzstan', value: 'KG' },
  { label: 'Laos', value: 'LA' },
  { label: 'Latvia', value: 'LV' },
  { label: 'Lebanon', value: 'LB' },
  { label: 'Lesotho', value: 'LS' },
  { label: 'Liberia', value: 'LR' },
  { label: 'Libya', value: 'LY' },
  { label: 'Liechtenstein', value: 'LI' },
  { label: 'Lithuania', value: 'LT' },
  { label: 'Luxembourg', value: 'LU' },
  { label: 'Macao', value: 'MO' },
  { label: 'Madagascar', value: 'MG' },
  { label: 'Malawi', value: 'MW' },
  { label: 'Malaysia', value: 'MY' },
  { label: 'Maldives', value: 'MV' },
  { label: 'Mali', value: 'ML' },
  { label: 'Malta', value: 'MT' },
  { label: 'Marshall Islands (the)', value: 'MH' },
  { label: 'Martinique', value: 'MQ' },
  { label: 'Mauritania', value: 'MR' },
  { label: 'Mauritius', value: 'MU' },
  { label: 'Mayotte', value: 'YT' },
  { label: 'Mexico', value: 'MX' },
  { label: 'Micronesia', value: 'FM' },
  { label: 'Moldova', value: 'MD' },
  { label: 'Monaco', value: 'MC' },
  { label: 'Mongolia', value: 'MN' },
  { label: 'Montenegro', value: 'ME' },
  { label: 'Montserrat', value: 'MS' },
  { label: 'Morocco', value: 'MA' },
  { label: 'Mozambique', value: 'MZ' },
  { label: 'Myanmar', value: 'MM' },
  { label: 'Namibia', value: 'NA' },
  { label: 'Nauru', value: 'NR' },
  { label: 'Nepal', value: 'NP' },
  { label: 'Netherlands', value: 'NL' },
  { label: 'New Caledonia', value: 'NC' },
  { label: 'New Zealand', value: 'NZ' },
  { label: 'Nicaragua', value: 'NI' },
  { label: 'Niger', value: 'NE' },
  { label: 'Nigeria', value: 'NG' },
  { label: 'Niue', value: 'NU' },
  { label: 'Norway', value: 'NO' },
  { label: 'Oman', value: 'OM' },
  { label: 'Pakistan', value: 'PK' },
  { label: 'Palau', value: 'PW' },
  { label: 'Panama', value: 'PA' },
  { label: 'Papua New Guinea', value: 'PG' },
  { label: 'Paraguay', value: 'PY' },
  { label: 'Peru', value: 'PE' },
  { label: 'Philippines', value: 'PH' },
  { label: 'Pitcairn', value: 'PN' },
  { label: 'Poland', value: 'PL' },
  { label: 'Portugal', value: 'PT' },
  { label: 'Puerto Rico', value: 'PR' },
  { label: 'Qatar', value: 'QA' },
  { label: 'Republic of North Macedonia', value: 'MK' },
  { label: 'Romania', value: 'RO' },
  { label: 'Russian Federation (the)', value: 'RU' },
  { label: 'Rwanda', value: 'RW' },
  { label: 'Réunion', value: 'RE' },
  { label: 'Saint Barthélemy', value: 'BL' },
  { label: 'Saint Helena, Ascension and Tristan da Cunha', value: 'SH' },
  { label: 'Saint Kitts and Nevis', value: 'KN' },
  { label: 'Saint Lucia', value: 'LC' },
  { label: 'Saint Martin (French part)', value: 'MF' },
  { label: 'Saint Pierre and Miquelon', value: 'PM' },
  { label: 'Saint Vincent and the Grenadines', value: 'VC' },
  { label: 'Samoa', value: 'WS' },
  { label: 'San Marino', value: 'SM' },
  { label: 'Sao Tome and Principe', value: 'ST' },
  { label: 'Saudi Arabia', value: 'SA' },
  { label: 'Senegal', value: 'SN' },
  { label: 'Serbia', value: 'RS' },
  { label: 'Seychelles', value: 'SC' },
  { label: 'Sierra Leone', value: 'SL' },
  { label: 'Singapore', value: 'SG' },
  { label: 'Sint Maarten (Dutch part)', value: 'SX' },
  { label: 'Slovakia', value: 'SK' },
  { label: 'Slovenia', value: 'SI' },
  { label: 'Solomon Islands', value: 'SB' },
  { label: 'Somalia', value: 'SO' },
  { label: 'South Africa', value: 'ZA' },
  { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
  { label: 'South Sudan', value: 'SS' },
  { label: 'Spain', value: 'ES' },
  { label: 'Sri Lanka', value: 'LK' },
  { label: 'Sudan (the)', value: 'SD' },
  { label: 'Suriname', value: 'SR' },
  { label: 'Sweden', value: 'SE' },
  { label: 'Switzerland', value: 'CH' },
  { label: 'Syrian Arab Republic', value: 'SY' },
  { label: 'Taiwan (Province of China)', value: 'TW' },
  { label: 'Tajikistan', value: 'TJ' },
  { label: 'Tanzania, United Republic of', value: 'TZ' },
  { label: 'Thailand', value: 'TH' },
  { label: 'Timor-Leste', value: 'TL' },
  { label: 'Togo', value: 'TG' },
  { label: 'Tokelau', value: 'TK' },
  { label: 'Tonga', value: 'TO' },
  { label: 'Trinidad and Tobago', value: 'TT' },
  { label: 'Tunisia', value: 'TN' },
  { label: 'Turkey', value: 'TR' },
  { label: 'Turkmenistan', value: 'TM' },
  { label: 'Turks and Caicos Islands (the)', value: 'TC' },
  { label: 'Tuvalu', value: 'TV' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Ukraine', value: 'UA' },
  { label: 'United Arab Emirates', value: 'AE' },
  { label: 'Great Britain', value: 'GB' },
  { label: 'Uruguay', value: 'UY' },
  { label: 'Uzbekistan', value: 'UZ' },
  { label: 'Vanuatu', value: 'VU' },
  { label: 'Venezuela', value: 'VE' },
  { label: 'Viet Nam', value: 'VN' },
  { label: 'British Virgin Islands', value: 'VG' },
  { label: 'Virgin Islands', value: 'VI' },
  { label: 'Wallis and Futuna', value: 'WF' },
  { label: 'Yemen', value: 'YE' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Zimbabwe', value: 'ZW' },
];

export const sivStatusIdOptions: Array<SivStatusOption> = [
  { label: 'Appeal Approved', value: 'AA' },
  { label: 'Abandoned', value: 'AB' },
  { label: 'Appeal Denied', value: 'AD' },
  { label: 'Active', value: 'AT' },
  { label: 'Approved', value: 'CA' },
  { label: 'Approved Applicant Contacted', value: 'CC' },
  { label: 'Closed Duplicate', value: 'CL' },
  { label: 'Not Approved', value: 'CN' },
  { label: 'Approved Applicant Unreachable Not Contacted', value: 'CU' },
  { label: 'Denied Applicant Contacted', value: 'DA' },
  { label: 'Documentation Complete', value: 'DC' },
  { label: 'Denied Applicant Unreachable Not Contacted', value: 'DU' },
  { label: 'Inactive 90 Days', value: 'I3' },
  { label: 'Inactive 180 Days', value: 'I6' },
  { label: 'Ineligible', value: 'IG' },
  { label: 'COM Approval Withdrawn Applicant Contacted', value: 'MA' },
  {
    label: 'COM Approval Withdrawn Applicant Unreachable Not Contacted',
    value: 'MU',
  },
  { label: 'COM Approval Withdrawn', value: 'MW' },
  { label: 'Not Approved Applicant Contacted', value: 'NA' },
  { label: 'Not Approved Applicant Not Contacted', value: 'NN' },
  { label: 'Referred To COM', value: 'RC' },
  { label: 'Referred To NVC', value: 'RN' },
  { label: 'Under Appeal', value: 'UA' },
  { label: 'Application Withdrawn', value: 'WD' },
  { label: 'Interagency Review Complete', value: 'IR' },
  { label: 'Interagency Review Incomplete', value: 'II' },
  { label: 'Unknown Other', value: 'XX' },
];
export const sivStatusToProcess: Array<SivStatus> = [
  'AB',
  'AD',
  'AT',
  'CN',
  'DA',
  'DC',
  'DU',
  'I3',
  'I6',
  'IG',
  'NA',
  'NN',
  'RN',
  'UA',
  'II',
  'IR',
  'XX',
];

export const sivStatuses: Array<SivStatus> = sivStatusToProcess.concat([
  'AA',
  'CA',
  'CC',
  'CL',
  'CU',
  'MA',
  'MU',
  'MW',
  'RC',
  'WD',
]);

export const flagTypes: Array<FlagType> = [
  'contract_date_mismatch',
  'work_period_quantity',
  'has_non_dod_work_periods',
  'dod_complete',
  'derog_flag',
  'admin_flag',
  'state_action_required',
  'unable_to_verify',
  'employer_not_in_rabbit',
];
export const notEmployedDetailOptionsArray = [
  {
    label: "I'm certain they did not work for us",
    value: 'did_not_work_certain',
  },
  {
    label: 'There is insufficient information to confirm this case',
    value: 'did_not_work_insufficient_info',
  },
];
export const booleanOptionsArray = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];
export const finalSubmissionOptionsArray = [
  {
    label: "Yes (this selection will submit this individual's information)",
    value: 'true',
  },
  {
    label: 'No (this selection will allow you to come back and edit this page)',
    value: 'false',
  },
];
export const pseudoFlags = {
  no_flags: 'No Flags',
  all_flags: 'All Flags',
};

// export const flags = {
//   contract_date_mismatch: 'Date Mismatch',
//   work_period_quantity: 'Work Period Quantity',
//   has_non_dod_work_periods: 'Has Non-DOD Contract',
//   dod_complete: 'DOD Complete',
//   derog_flag: 'Derog Flag',
//   admin_flag: 'Admin',
//   state_action_required: 'State Action Required',
//   unable_to_verify: 'Unable to Verify',
// };

// export const allFlags = {
//   ...pseudoFlags,
//   ...flags,
// };
export const flagOptions: Array<FlagTypeOption> = [
  { label: 'Date Mismatch', value: 'contract_date_mismatch' },
  { label: 'Work Period Quantity', value: 'work_period_quantity' },
  { label: 'Has Non-DOW Contract', value: 'has_non_dod_work_periods' },
  { label: 'DOW Complete', value: 'dod_complete' },
  { label: 'Derog Flag', value: 'derog_flag' },
  { label: 'Admin', value: 'admin_flag' },
  { label: 'State Action Required', value: 'state_action_required' },
  { label: 'Unable to Verify', value: 'unable_to_verify' },
  { label: 'Employer is not in Rabbit', value: 'employer_not_in_rabbit' },
];

export const psuedoFlagOptions = [
  { label: 'All Flags', value: 'all_flags' },
  { label: 'No Flags', value: 'no_flags' },
];

export const allFlagOptions = [...flagOptions, ...psuedoFlagOptions];
